module.exports = __webpack_public_path__ + "static/media/S1_00013.45bb5ab2.jpg";